<div class="modal-container">
  <h1 i18n>Do you want to delete this user?</h1>
  <section class="buttons">
    <button class="close-button" (click)="closeModal()">Cancel</button>
    <button class="submit-button" (click)="deleteUser()">Yes</button>
  </section>
</div>
